
import afntyIcon from "../../imgs/AFNTY_icon.png";
import btcbIcon from "../../imgs/BTCB_icon.png";
import sfmIcon from "../../imgs/SFM_icon.png";
import incnIcon from "../../imgs/INCN_icon.png";

export const getGradientCardStyle = (icon, bgSize, startColor, endColor) => ({
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    backgroundImage: `linear-gradient(309deg, ${startColor}, ${endColor}), url(${icon}), linear-gradient(153deg, #ff2424, #b40606 19%, #470000)`,
    backgroundPosition:  '0px 0px, 115% 25%, 0px 0px, 115% 50%, 0px 0px',
    backgroundSize: bgSize,
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    gridColumn: 'span 2',
    gridRow: 'span 1'
});

export const childBurnCardStyle = {
  background: "#333333",
  borderRadius: "15px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  border: '1px solid rgba(255, 255, 255, 0.2)', // A subtle border to fit inside the parent card
  padding: '10px', // Some padding inside the child cards
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', // A slight shadow for depth
  gridColumn: 'span 1', // Take up only one column span
};

export const cardStyle = {
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    gridColumn: 'span 2',
    gridRow: 'span 1'
};

export const cardStyleSmartRewards = {
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '20px',
    paddingBottom: '20px',
    gridColumn: "span 3",
    gridRow: "span 1",
}


export const bannerStyle = {
    background: "#fff",
    borderRadius: "20px",
    color: "#333333",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    gridColumn: 'span 4',
    gridRow: 'span 4'
};

export const cardHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: 'rgba(255, 255, 255, .7)',
};

export const cardHeaderInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#333333',
};

export const cardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 2",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };

  export const cardOutlineSmallStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 2",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };

  export const walletCardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 2",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };

  export const cardSmartRewardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 3",
    gridRow: "span 4",
    background: "none", // Set the background to none or transparent
  };

  export const cardOutlineExtendedStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 3",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };
  
  export const cardOutlineHeaderStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgba(255, 255, 255, .9)", // Slightly increase opacity for better visibility
  };

  export const infoOutlineStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "39px",
    color: "rgba(255, 255, 255, .9)", // Slightly increase opacity for better visibility
  };

  export const infoOutlineStyleSmall = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "18px", // Smaller font size
    lineHeight: "28px", // Adjust line height according to new font size
    color: "rgba(255, 255, 255, .9)",
  };
  
  
  export const miniCardHeaderOutlineStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgba(255, 255, 255, .7)',
};

export const miniInfoOutlineStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: 'rgba(255, 255, 255, .7)',
};

export const cardOutlineInvertStyle = {
    border: "1px solid rgb(51, 51, 51)", // Add border instead of background
    borderRadius: "20px",
    color: "rgb(51, 51, 51)",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 3",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };
  
  export const cardOutlineInvertHeaderStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgb(51, 51, 51)", // Slightly increase opacity for better visibility
  };

  export const infoOutlineInvertStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "39px",
    color: "rgb(51, 51, 51)", // Slightly increase opacity for better visibility
  };
  
  export const miniCardHeaderOutlineInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgb(51, 51, 51, .7)',
};

export const miniInfoOutlineInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: 'rgb(51, 51, 51, .7)',
};


export const miniCardHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgba(255, 255, 255, .7)',
};

export const miniCardHeaderInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: '#333333',
};



export const bannerHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#333333',
};

export const infoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '39px',
    color: '#FFFFFF',
};


export const miniInfoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#FFFFFF',
};

export const miniInfoInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#333333',
};


export const bannerInfoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '39px',
    color: '#333333',
};

export const imgGradientCardStyle = {

        background: "#333333",
        borderRadius: "20px",
        color: "#FFFFFF",
        marginBottom: "10px",
        fontFamily: 'Inter, sans-serif',
        backgroundImage: `linear-gradient(309deg, rgb(255 161 135 / 94%), rgb(176 14 146 / 86%)), linear-gradient(153deg, rgb(255, 36, 36), rgb(180, 6, 6) 19%, rgb(71, 0, 0))`,
        backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
        backgroundSize: 'auto, auto 135%, auto',
        backgroundRepeat: 'repeat, repeat-y, repeat',
        backgroundAttachment: 'scroll, scroll, scroll',
        gridColumn: 'span 1',
        gridRow: 'span 1'

};

export const afntyCardStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  backgroundImage: `linear-gradient(309deg, rgb(255 161 135 / 94%), rgb(176 14 146 / 86%)), url(${afntyIcon}), linear-gradient(153deg, rgb(255, 36, 36), rgb(180, 6, 6) 19%, rgb(71, 0, 0))`,
  backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
  backgroundSize: 'auto, auto 135%, auto',
  backgroundRepeat: 'repeat, repeat-y, repeat',
  backgroundAttachment: 'scroll, scroll, scroll',
  gridColumn: 'span 1',
  gridRow: 'span 1'
};

export const btcbCardStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  backgroundImage: `linear-gradient(263deg, rgb(236 103 255 / 89%), rgb(51 107 187 / 89%)), url(${btcbIcon}), linear-gradient(309deg, rgb(66, 0, 0, 0.94), rgb(151, 0, 0, 0.86))`,
  backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
  backgroundSize: 'auto, auto 135%, auto',
  backgroundRepeat: 'repeat, repeat-y, repeat',
  backgroundAttachment: 'scroll, scroll, scroll',
  gridColumn: 'span 1',
  gridRow: 'span 1'
};

export const incnCardStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  backgroundImage: `linear-gradient(309deg, rgb(255 161 135 / 94%), rgb(176 14 146 / 86%)), url(${incnIcon}), linear-gradient(153deg, rgb(255, 36, 36), rgb(180, 6, 6) 19%, rgb(71, 0, 0))`,
  backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
  backgroundSize: 'auto, auto 135%, auto',
  backgroundRepeat: 'repeat, repeat-y, repeat',
  backgroundAttachment: 'scroll, scroll, scroll',
  gridColumn: 'span 1',
  gridRow: 'span 1'
};

export const sfmCardStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  backgroundImage: `linear-gradient(263deg, rgb(236 103 255 / 89%), rgb(51 107 187 / 89%)), url(${sfmIcon}), linear-gradient(309deg, rgb(66, 0, 0, 0.94), rgb(151, 0, 0, 0.86))`,
  backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
  backgroundSize: 'auto, auto 135%, auto',
  backgroundRepeat: 'repeat, repeat-y, repeat',
  backgroundAttachment: 'scroll, scroll, scroll',
  gridColumn: 'span 1',
  gridRow: 'span 1'
};


export const communityStyle = {
  background: "linear-gradient(309deg, rgba(44, 1, 78, 1), rgba(181, 199, 255, 1))",
  borderRadius: "20px",
  color: "#333333",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  gridColumn: 'span 2',
  gridRow: 'span 2'
};

export const rewardZoneStyle = {
  background: "linear-gradient(309deg, rgba(255, 240, 232, 1), rgba(133, 188, 255, 1))",
  borderRadius: "20px",
  color: "#333333",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  gridColumn: 'span 3',
  gridRow: 'span 3'
};

export const rewardSelectionStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#FFFFFF",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  gridColumn: 'span 2',
  gridRow: 'span 2'
};



export const communityHeaderStyle = {
  fontFamily: 'Inter, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  color: '#333333',
};

export const rewardZoneHeaderStyle = {
  fontFamily: 'Inter, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  color: '#333333',
};

export const dashletHeaderStyle = {
  fontFamily: 'Inter, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px',
  color: '#333333',
};
